<template>
  <common-layout>

    <div class="top">

      <div class="header">
        <!--        <img alt="logo" class="logo" src="@/assets/img/logo.png"/>-->
        <span class="title">{{ systemName }}</span>
      </div>
      <div class="boxes" style="width: 100%;margin-top:200px" v-if="showInput3===false">
        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=win&from=baidu">
          <div class="first big">
            <div class="small"></div>
            <span>Windows桌面端</span>
            <p class="p1">点击直接下载</p>
          </div>
        </a>
        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=mac&from=baidu">
          <div class="second big">
            <div class="small"></div>
            <span>Mac桌面端</span>
            <p class="p2">点击直接下载</p>
          </div>
        </a>
        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=ios&from=baidu">
          <div class="third big">
            <div class="small"></div>
            <span>IOS版</span>
            <p class="p3">扫描二维码下载</p>
          </div>
        </a>
        <a href="https://work.weixin.qq.com/wework_admin/commdownload?platform=android&from=baidu">
          <div class="forth big">
            <div class="small"></div>
            <span>Android版</span>
            <p class="p4">扫描二维码下载</p>
          </div>
        </a>
      </div>
      <span style="margin-top: 100px;height: 20px;display: block" v-if="showInput3===false">请使用
        <span class="spana" @click="toHere1">企</span>业微信内个
        <span class="spana" @click="toHere2">人</span>中心
        <span class="spana" @click="toHere3">登</span>录
      </span>
    </div>

        <div v-if="showInput3===true" class="login">
          <a-form @submit="onSubmit" :form="form">
            <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;">
              <a-tab-pane tab="账户密码登录" key="1">
                <a-alert type="error" :closable="true" v-show="error" :message="error" showIcon
                         style="margin-bottom: 24px;"/>
                <a-form-item>
                  <a-input
                      autocomplete="autocomplete"
                      size="large"
                      placeholder="请输入账户名"
                      v-decorator="['username', {rules: [{ required: true, message: '请输入账户名', whitespace: true}]}]"
                  >
                    <a-icon slot="prefix" type="user"/>
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-input
                      size="large"
                      placeholder="请输入密码"
                      autocomplete="autocomplete"
                      type="password"
                      v-decorator="['password', {rules: [{ required: true, message: '请输入密码', whitespace: true}]}]"
                  >
                    <a-icon slot="prefix" type="lock"/>
                  </a-input>
                </a-form-item>
                <!-- qf04 -->
                <a-form-item>
                  <a-input
                          size="large"
                          placeholder="请输入验证码"
                          autocomplete="autocomplete"
                          style="width: 60%"
                          type="text"
                          v-decorator="['code', {rules: [{ required: true, message: '请输入验证码', whitespace: true}]}]"
                  >
                  </a-input>
                  <div class="login-code">
                    <img :src="codeUrl" @click="getCode" class="login-code-img"/>
                  </div>
                </a-form-item>
              </a-tab-pane>
            </a-tabs>
            <a-form-item>
              <a-button :loading="logging" style="width: 100%;margin-top: 24px" size="large" htmlType="submit"
                        type="primary">登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
  </common-layout>
</template>

<script>
import CommonLayout from '@/layouts/CommonLayout'
import {login, getRoutesConfig, getUserInfo, getPermissions,getCodeImg} from '@/services/user'
console.log(getCodeImg)
import {setAuthorization} from '@/utils/request'
import {loadRoutes} from '@/utils/routerUtil'
import {mapMutations} from 'vuex'
import {convertMenuConfigToRouteConfig} from '@/utils/ebase-menu'
import api from '@/services/api'
import Cookie from "js-cookie";
import { Wxlogin } from '@/api/user.js'
// Wxlogin
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import CryptoJS from 'crypto-js';
/**
 * 处理权限数据为目标格式
 * @param arr
 */
function dealPermissions(arr) {
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return [];
  }
  let pArr = [];
  arr.map((val) => {
    if (!val) val = '';
    // let busStr = 'per_' + val.split(':')[0] || '';
    let busStr = val.split(':')[0] || '';
    let funcStr = val.split(':')[1] || '';
    let testArr = pArr.map((v, i) => {
      return {
        id: v.id,
        idx: i
      };
    }).filter((v) => {
      return busStr === v.id;
    });

    if (testArr.length > 0) {
      pArr[testArr[0].idx].operation.push(funcStr);
    } else {
      pArr.push({
        id: busStr,
        operation: [funcStr] //权限下的操作权限
      })
    }
  })
  return pArr;
}

export default {
  name: 'Login',
  components: {CommonLayout},
  data() {
    return {
      showInput1:false,
      showInput2:false,
      showInput3:true,
      // showInput3:true,


      logging: false,
      error: '',
      form: this.$form.createForm(this),
      codeUrl: '', //验证码图片
      uuid:'',
      code:''  //验证码
    }
  },
  computed: {
    systemName() {
      return this.$store.state.setting.systemName
    }
  },
  mounted() {
    if (this.$route.query.userId && this.$route.query.token) {
      const res = {
        code: 200,
        data: {
          token: this.$route.query.token,
          userId: this.$route.query.userId,
          expire: 86400
        }
      }
      this.afterLogin(res)
    }
    this.uuid = uuidv4()
    this.getCode();
    if (window.location.href.indexOf("code") > 0) {
      const code = window.location.href.split("code=")[1].split("&state")[0];
      console.log(code);
      this.wxLoginSubmit(code)
    }
  },
  methods: {
    toHere1(){
      this.showInput1=true
    },
    toHere2(){
      if(this.showInput1===true)
      this.showInput2=true
    },
    toHere3(){
      if(this.showInput2===true)
        this.showInput3=true
    },
    ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
    //  企业微信登录接口
    wxLoginSubmit(code) {
      let params = {
        code: code
      }
      Wxlogin(params).then(res => {
        let data = res.data
        if (res.code === 1 && res.data) {
          const res = {
            code: 200,
            data: {
              token: data.tokenValue,
              userId: data.userId,
              expire: data.expire
            }
          }
          this.afterLogin(res)
          console.log(res,'----企业微信登录的返回值----');
        }else {
          this.$message.error(res.message)
        }
      })
    },
    onSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err) => {
        if (!err) {
          this.logging = true
          const username = this.form.getFieldValue('username')
          const password = this.form.getFieldValue('password')
          const code = this.form.getFieldValue('code')
          const uuid = this.uuid;
          // 生成随机 AES 密钥
          const aesKey = CryptoJS.enc.Utf8.parse("X7uFEFdMmBYfZyax");
          // 加密
          const password1 = CryptoJS.enc.Utf8.parse(password);

          let encryptedData = CryptoJS.AES.encrypt(password1, aesKey, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          const encryptedPassword = encryptedData.ciphertext.toString()
          const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedPassword);
          const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
          const decrypt = CryptoJS.AES.decrypt(srcs, aesKey, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          console.log("decrypt",decrypt.toString(CryptoJS.enc.Utf8));
          Cookie.set('Authorization', 'Bearertoken') // 设置默认token防止登录报错
          let _this = this
          login(username, encryptedPassword,code,uuid)
          // login(username, password)

              .then(this.afterLogin)
              .catch(function () {
                // _this.$message.error(res.msg)
                console.log("登录失败")
                _this.getCode();
                _this.logging = false
              })
        }
      })
    },
    afterLogin(res) {
       // 将登录状态标记为false，表示登录过程结束
      this.logging = false
      const loginRes = res.data;
      if (res.code >= 200 && res.code < 300) {
        // 解构获取token和expire字段
        const {token, expire} = loginRes;
        // 将token存入localStorage
        localStorage.setItem('token', loginRes.token)
        // 设置授权信息
        setAuthorization({token: loginRes.token, expireAt: new Date(new Date().valueOf() + loginRes.expire * 1000)})
        getUserInfo().then(result => {
          console.log(result,'-----登陆之后的操作');
          
          const user = {
            userId: result.data.userId,
            token,
            expire,
            name: result.data.userName,
            avatar: result.data.headImg ? api.temp.FILE_PATH + result.data.headImg : require('@/assets/img/moren.png')
          }
          Cookie.set('shopId', result.data.shopId) // 设置默认token防止登录报错  将shopId存入cookie
          // 设置用户信息
          this.setUser(Object.assign(result.data, user)); 
        })

        getPermissions().then(result => {
          const permissions = dealPermissions(result.data);
          this.setPermissions(permissions || [])
        })

        // 获取路由配置
        getRoutesConfig().then(result => {
          // 提取路由配置数据
          const routesConfig = result.data
          // 将菜单数据格式转换为路由格式
          const vueRoutesConfig = convertMenuConfigToRouteConfig(routesConfig)
          // 加载路由
          loadRoutes(vueRoutesConfig)

          // 如果地址上传入了to参数，则尝试跳转到to指向的地址
          // 参考guard.js -> loginGuard()
          // 获取路由查询参数
          const routeQuery = this.$route.query
          // 确定目标路由     如果前面的表达式routeQuery && routeQuery.to结果为false（即routeQuery不存在或routeQuery.to为null/undefined）/workspace-首页
          const destRoute = routeQuery && routeQuery.to || '/workspace'
          // const destRoute = routeQuery && routeQuery.to || '/terminalActivity/myToDolist'
          
          this.$router.push(destRoute)
          // this.$message.success('登陆成功', 3)


        }).catch(e => {
          const vueRoutesConfig = convertMenuConfigToRouteConfig([])
          loadRoutes(vueRoutesConfig);
          const routeQuery = this.$route.query
          const destRoute = routeQuery && routeQuery.to || '/workspace'
          // const destRoute = routeQuery && routeQuery.to || '/terminalActivity/myToDolist'

          this.$router.push(destRoute)
          this.$message.error(e.msg, 3)
        })

      } else {
        this.error = loginRes.message
      }
    },
    getCode(){
      if (!this.uuid){
        this.$message.error("获取验证码失败", 3)
        return;
      }
      const params = {
        uuid: this.uuid
      };
      axios({
        url: `${process.env.VUE_APP_API_BASE_URL}/BASE-SERVE/captcha.jpg`,
        params,
        responseType: 'blob'
      }).then(response => {
        console.log("response,",response)
        this.codeUrl =  URL.createObjectURL(response.data)
      }).catch( error => {
        console.log('错误', error.message)
        this.$message.error("获取验证码失败", 3)
      })
    }
  }
}
</script>

<style lang="less" scoped>
//.ww_officialImg_DownloadIcon{
//  background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
//  background-position: 0 -89px;
//  width: 90px;
//  height: 90px;
//}
.ant-form {
  padding-right: 0;
}

.common-layout {
  .top {
    text-align: center;
    .spana{
      margin-left: -3px;
    }
    .boxes {
      .big {
        width: 120px;
        height: 120px;
        display: inline-block;
        margin-right: 50px;
        .small{

          opacity: 0;
          float: left;
          margin-left: 15px;
          margin-top: 20px;
          width: 90px;
          height: 90px;
          //background-color: #8c8c8c;
        }
      span {
        display: inline-block;
        margin-top: 30px;
        font-size: 16px;
      }
      p{
        color: #c2c1c1;
        opacity: 0;
      }
    }
      .first {
        margin-left: 50px;
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: 0 -120px;
        width: 120px;
        height: 120px;
        .small{
          background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
          background-position: 0 -89px;
        }
      }

      .first:hover {
        background: transparent;

        .small{
          opacity: 100;
        }
        .p1{
          opacity: 100;
        }
      }

      .second {
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: -120px 0;
        width: 120px;
        height: 120px;
        .small{
          background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$64a1bb5d.png);
          background-position: 0 -89px;
        }
      }

      .second:hover {
        background: transparent;
        .small{
          opacity: 100;
        }
        .p2{
          opacity: 100;
        }

      }

      .third {
        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: -120px -120px;
        width: 120px;
        height: 120px;
      }
      .third:hover {
        background-image: url(https://work.weixin.qq.com/wework_admin/genqrcode?action=commdownload&platform=ios&from=baidu&qr_size=4);
        background-size: 100%;
        .p3{
          opacity: 100;
        }
      }

      .forth {

        background-image: url(https://wwcdn.weixin.qq.com/node/wwnl/wwnl/style/images/officialImages$7ef49462.svg);
        background-position: 0 0px;
        width: 120px;
        height: 120px;
      }
      .forth:hover {

        background-image: url(https://work.weixin.qq.com/wework_admin/genqrcode?action=commdownload&platform=android&from=baidu&qr_size=4);
        background-size: 100%;
        .p4{
          opacity: 100;
        }
      }
    }

    .header {
      height: 44px;
      line-height: 44px;


      a {
        text-decoration: none;
      }

      .logo {
        height: 44px;
        vertical-align: top;
        margin-right: 16px;
      }

      .title {
        font-size: 33px;
        color: @title-color;
        font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
        font-weight: 600;
        position: relative;
        top: 2px;
      }


    }

    .desc {
      font-size: 14px;
      color: @text-color-second;
      margin-top: 12px;
      margin-bottom: 40px;
    }
  }

  .login {
    width: 368px;
    margin: 0 auto;
    @media screen and (max-width: 576px) {
      width: 95%;
    }
    @media screen and (max-width: 320px) {
      .captcha-button {
        font-size: 14px;
      }
    }

    .icon {
      font-size: 24px;
      color: @text-color-second;
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.login-code-img {
  height: 100%;
  width: 100%;
}
</style>
